import { all } from 'redux-saga/effects'
import { LocationSagas } from 'sagas/Location'
/**
 * Generator principal onde são centralizadas todas as sagas do middleware
 */
export default function* RootSagas() {
    yield all([
      LocationSagas()
    ])
}